const THIRTY_DAYS = 2_592_000_000;

const addBoostNotificationToQueue = async (
  addToQueue: WorkerQueryArgs['addToQueue'],
  data: unknown,
) =>
  addToQueue({
    data,
    type: 'boost',
    priority: 'high',
    sticky: true,
    dismissStrategy: { storage: 'cookie', ttl: THIRTY_DAYS },
  });

export default addBoostNotificationToQueue;
